import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class AfterSalesAppliances extends Page{
    constructor(){
        super({
            id : 'after_sales_appliances',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}